import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MarkOrdersForInvoicingMutationVariables = Types.Exact<{
  input: Types.MarkOrdersForInvoicingInput;
}>;


export type MarkOrdersForInvoicingMutation = { __typename?: 'Mutation', markOrdersForInvoicing: { __typename?: 'MarkOrdersForInvoicingPayload', invoices?: Array<{ __typename?: 'InvoiceStateData', invoiceId: string, invoiceNumber: string, orderId: string, taxStatus: Types.InvoiceTaxStatus }> | null, failures?: Array<{ __typename?: 'InvoiceIssueFailureData', orderId: string, code: string, message: string }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const MarkOrdersForInvoicingDocument = new TypedDocumentString(`
    mutation MarkOrdersForInvoicing($input: MarkOrdersForInvoicingInput!) {
  markOrdersForInvoicing(input: $input) {
    invoices {
      invoiceId
      invoiceNumber
      orderId
      taxStatus
    }
    failures {
      orderId
      code
      message
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MarkOrdersForInvoicing: build.mutation<MarkOrdersForInvoicingMutation, MarkOrdersForInvoicingMutationVariables>({
      query: (variables) => ({ document: MarkOrdersForInvoicingDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMarkOrdersForInvoicingMutation } = injectedRtkApi;
